module.exports = function () {

    let module = {};

    module.environment = process.env.NODE_ENV;
    module.isLive = (module.environment == 'production') ? true : false;
    module.isStaging = (module.environment == 'staging') ? true : false;
    module.isMobile = (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) ? true : false;


    module.log = function (message) {
        if (!module.isStaging && !module.isLive)
            return console.log(message);
    };

    // Only include Bootstrap modules required
    module.initBootstrap = function () {
        require('bootstrap/js/dist/index');
        require('bootstrap/js/dist/alert');
        require('bootstrap/js/dist/button'); // required for auto complete library
        //require('bootstrap/js/dist/carousel');
        require('bootstrap/js/dist/collapse');
        require('bootstrap/js/dist/dropdown');
        require('bootstrap/js/dist/modal');
        // require('bootstrap/js/dist/popover');
        // require('bootstrap/js/dist/scrollspy');
        // require('bootstrap/js/dist/tab');
        // require('bootstrap/js/dist/tooltip');
        // require('bootstrap/js/dist/util');
    };

    // module.initDatepicker = function () {
    //     require('jquery-ui/ui/keycode');
    //     require('jquery-ui/ui/widgets/datepicker');
    //
    //     $('.datepicker').datepicker({
    //         dateFormat: "d MM yy",
    //         changeMonth: true,
    //         changeYear: true,
    //         maxDate: "-18y"
    //     });
    // }


    module.initLazyLoad = function () {
        const lasysizes = require('lazysizes/lazysizes');
        lazySizes.cfg.lazyClass = 'lazy';
    };

    module.initRrssb = function () {
        require('rrssb');
    };

    module.initPopups = function () {
        if ($('#popupModal').length) {
            let id = $('#popupModal').data('id');
            let popupShown = localStorage.getItem('popup-' + id + '-shown');
            let expirationDate = localStorage.getItem('popup-' + id + '-expiration');

            // Check if the popup has been shown and if the expiration date has passed
            if (!popupShown || Date.now() > parseInt(expirationDate)) {
                let delay = parseInt($('#popupModal').data('delay') + '000');
                let next_display_time = parseInt($('#popupModal').data('next-display-time'));
                const expirationTime = Date.now() + (next_display_time ? next_display_time : 7) * 24 * 60 * 60 * 1000; // Current time + 7 days in milliseconds

                setTimeout(function () {
                    $('#popupModal').modal('show');
                    localStorage.setItem('popup-' + id + '-shown', 'true');
                    localStorage.setItem('popup-' + id + '-expiration', expirationTime.toString());
                }, delay ? delay : 2000);
            }
        }
    };

    module.keepTokenAlive = function () {

        // To override the default mins, add a <body> data tag value for 'token_minutes'
        let keepAlive = $('body').data('token-minutes');

        setInterval(keepTokenAlive, 1000 * 60 * (keepAlive ? keepAlive : 3)); // every 3 or x mins

        function keepTokenAlive() {
            $.ajax({
                url: '/keep-token-alive', //https://stackoverflow.com/q/31449434/470749
                method: 'post',
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
            }).then(function (result) {
                console.log(new Date() + ' ' + result + ' ' + $('meta[name="csrf-token"]').attr('content'));
            });
        }
    }

    module.initTooltips = function () {

        $('[data-toggle="tooltip"]').tooltip({
            trigger: 'hover focus',
            placement: 'bottom',
            container: 'body'
        });
    };


    module.initStickyEl = function () {

        // Get sticky el's
        let el = $('.is-sticky');

        sessionStorage.setItem('height', $('header').height());

        // When the user scrolls the page, execute myFunction
        window.onscroll = function () {
            module.addStickyClass();
        };

        module.addStickyClass();
    };

    module.addStickyClass = function () {

        let body = $('body');

        let height = sessionStorage.getItem('height') ? sessionStorage.getItem('height') : $('header').height();

        if (window.pageYOffset >= (height / 2) && window.pageYOffset < height) {
            body.addClass("before-stuck").removeClass("stuck").css('padding-top', '0');
        } else if (window.pageYOffset == 0) {
            body.removeClass("stuck").removeClass("before-stuck").css('padding-top', '0');
        } else if (window.pageYOffset > height) {
            body.addClass("stuck").removeClass("before-stuck").css('padding-top', height + 'px');

        }

    };


    // module.navDropdownHover = function () {
    //
    //     const $dropdown = $(".dropdown");
    //     const $dropdownToggle = $(".dropdown-toggle");
    //     const $dropdownMenu = $(".dropdown-menu");
    //     const showClass = "show";
    //
    //     $(window).on("load resize", function() {
    //         if (this.matchMedia("(min-width: 768px)").matches) {
    //             $dropdown.hover(
    //                 function() {
    //                     const $this = $(this);
    //                     $this.addClass(showClass);
    //                     $this.find($dropdownToggle).attr("aria-expanded", "true");
    //                     $this.find($dropdownMenu).addClass(showClass);
    //                 },
    //                 function() {
    //                     const $this = $(this);
    //                     $this.removeClass(showClass);
    //                     $this.find($dropdownToggle).attr("aria-expanded", "false");
    //                     $this.find($dropdownMenu).removeClass(showClass);
    //                 }
    //             );
    //         } else {
    //             $dropdown.off("mouseenter mouseleave");
    //         }
    //     });
    // };


    module.announcementBarDismiss = function () {
        if ($('#announcement-dismiss').length) {
            $('#announcement-dismiss').click(function () {
                $.get("/announcement-dismiss", function () {
                    console.log("Announcement bar dismissed");
                    $('#announcement-dismiss').fadeOut(300);
                })
            });
        }
    };

    module.initSpotlightJs = function () {
        if ($('.spotlight').length)
            require('spotlight.js');
    };


    module.initTingleModalJs = function () {

        const Tingle = require('tingle.js');

        var modal = new Tingle.modal({
            stickyFooter: false,
            footer: false,
            closeMethods: ['overlay', 'button', 'escape'],
            cssClass: ['custom-class-1', 'custom-class-2'],
        });

        $('.md-trigger').click(function (event) {
            let id = $(this).data('id');
            modal.setContent($('#' + id).html());
            modal.open();
        });
    };

    module.initLightbox = function () {
        require('ekko-lightbox');
        $(document).on('click', '[data-toggle="lightbox"]', function (event) {
            event.preventDefault();
            $(this).ekkoLightbox({
                alwaysShowClose: true,
                leftArrow: '<i class="fa fa-chevron-left left"></i>',
                rightArrow: '<i class="fa fa-chevron-right right"></i>'
            });
        });
    };

    module.initMobileMenu = function () {
        require('../plugins/jquery-simple-mobile-menu');
        $(".mobile_menu").simpleMobileMenu();
        $('#sm_menu_ham').addClass('icon').prependTo('.mobile-icons');
    };

    module.initSlickCarousel = function () {
        require('@accessible360/accessible-slick');

        $('.slick.testimonial-cards').slick({
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay: true,
            arrows: true,
            cssEase: 'linear',
            prevArrow: $('.testi-prev'),
            nextArrow: $('.testi-next'),

            responsive: [

                {
                    breakpoint: 1150, // sm
                    settings: {
                        slidesToShow: 2
                    }
                },

                {
                    breakpoint: 920, // sm
                    settings: {
                        slidesToShow: 1
                    }
                },

            ]


        });

        $('.slick.shortcode-slider').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            fade: true,
            arrows: false,
            dots: true,
            cssEase: 'linear',
        });

        $('.slick.main-slider').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            arrows: false,
            dots: true,
            fade: true,
            speed: 1000,
            cssEase: 'linear'
        });

        $('.carousel').slick({
            slidesToShow: 6,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2500,
            arrows: false,
            dots: false,
            infinite: true,
            speed: 600,
            cssEase: 'ease',
            responsive: [
                {breakpoint: 1200, settings: {slidesToShow: 5}},
                {breakpoint: 992, settings: {slidesToShow: 4}},
                {breakpoint: 768, settings: {slidesToShow: 3}},
                {breakpoint: 576, settings: {slidesToShow: 2}}
            ]
        });

        $('.cards-carousel').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
            arrows: false,
            dots: true,
            speed: 500,
            cssEase: 'ease',
            responsive: [
                {
                    breakpoint: 1105, settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 950, settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 600, settings: {
                        slidesToShow: 1,
                    }
                }
            ]
        });

        $('.tiles-carousel').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
            arrows: true,
            dots: true,
            speed: 500,
            cssEase: 'ease',
            responsive: [
                {breakpoint: 992, settings: {slidesToShow: 2}},
                {breakpoint: 576, settings: {slidesToShow: 1, dots: true, arrows: false}}
            ]
        });

        $('.slick.cards.benefits-carousel').slick({
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            infinite: false,
            speed: 450,
            cssEase: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
            prevArrow: $('.benefits-prev'),
            nextArrow: $('.benefits-next'),
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });

        $('.rail-list').slick({
            mobileFirst: true,
            slidesToShow: 1,
            variableWidth: true,
            arrows: false,
            dots: false,
            infinite: false,
            swipeToSlide: true,

            responsive: [
                {
                    breakpoint: 992,
                    settings: 'unslick'
                }
            ]
        });

        $('.tablet-carousel').slick({
            mobileFirst: true,
            slidesToShow: 1,
            arrows: true,
            dots: true,
            infinite: false,
            swipeToSlide: true,
            responsive: [
                {
                    breakpoint: 759,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 992,
                    settings: 'unslick',
                }
            ]

        });


        $('.slick-carousel.projects-gallery').slick({
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            //variableWidth: false,
            //adaptiveHeight: false,
            arrows: true,
            dots: false,
            prevArrow: $('.image-prev'),
            nextArrow: $('.image-next'),

            responsive: [

                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3,
                        centerPadding: '50px'
                    }
                },
                {
                    breakpoint: 1100,
                    settings: {
                        slidesToShow: 2,
                        centerPadding: '50px'
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        centerPadding: '50px'
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        centerPadding: '10px'
                    }
                }
            ],

        });

    };


    module.scrollToAnchor = function () {
        $('a[href^=\\#scroll-]').on('click', function (e) {
            e.preventDefault();

            let collapseId = $(this).attr('href').replace('scroll-', '');

            console.log(collapseId);

            module.scrollToElement(collapseId);
        });
    };


    module.detectUrlScrollHash = function () {
        if (window.location.hash.indexOf('scroll-') == 1) {

            let el = window.location.hash.replace('scroll-', '');

            console.log('Attempting automatic scroll to ' + el);

            this.scrollToElement(el);
        }
    };

    module.scrollToElement = function (element) {
        console.log('Attempt to scroll to el ' + element);
        $('html,body').animate({scrollTop: $(element).offset().top - 100}, 'slow', function () {
            if ($(element).length && $(element).next().hasClass('collapse')) {
                $(element).next().collapse('show');
            }
        });
    };

    module.scrollToAccordionItem = function () {

        $('.accordion').on('shown.bs.collapse', function (event) {
            let getHeaderEl = $('#' + event.target.id).prev('.card-header').attr('id');

            if (getHeaderEl)
                module.scrollToElement('#' + getHeaderEl);
        });

    };

    module.initWowJs = function () {
        const {WOW} = require('wowjs');
        new WOW({
            mobile: false,
        }).init();
    };


    module.convertCryptedEmails = function () {

        $('.cryptedmail').each(function () {

            let
                el = $(this).find('span'),
                e = el.data('name') + '@' + el.data('domain') + '.' + el.data('tld');

            $(this).attr('href', 'mailto:' + e).removeClass('cryptedmail').find('span');

            if ((typeof el.data('show-value') == 'undefined') || el.data('show-value'))
                el.html(el.data('value') ? el.data('value') : e);
        });
    };

    module.cardsProgress = function () {

        var $benefitsCarousel = $('.slick.cards.benefits-carousel');
        var $benefitsWrap = $benefitsCarousel.closest('.benefits-carousel-wrap');
        var $benefitsCounter = $benefitsWrap.find('.current-slide');
        var $benefitsTotal = $benefitsWrap.find('.total-slides');
        var $benefitsBar = $benefitsWrap.find('.carousel-progress .bar');

// Count children BEFORE slick wraps them
        var benefitsTotalCards = $benefitsCarousel.children().length;

        function updateBenefitsProgress(slick, currentSlide) {
            var slidesToShow = slick.options.slidesToShow;
            var maxIndex = benefitsTotalCards - slidesToShow;

            // Progress: 0% at start, 100% when last card is in view
            var pct = maxIndex > 0 ? ((currentSlide / maxIndex) * 100) : 100;
            $benefitsBar.css('width', pct + '%');

            // Counter: first visible card (1-based)
            $benefitsCounter.text(currentSlide + 1);
        }

// Set total and initial state on slick init
        $benefitsCarousel.on('init', function (event, slick) {
            $benefitsTotal.text(benefitsTotalCards);
            updateBenefitsProgress(slick, 0);
        });

// Update on slide change
        $benefitsCarousel.on('afterChange', function (event, slick, currentSlide) {
            updateBenefitsProgress(slick, currentSlide);
        });


    };

    module.sliderDroneAnimation = function () {
        (function () {
            var wrapper = document.querySelector('[data-drone]');

            if (!wrapper) {
                return;
            }

            var slider = wrapper.parentElement;
            var drone = wrapper.querySelector('.drone');
            var shadow = wrapper.querySelector('.drone-shadow');
            var line = wrapper.querySelector('.scan-line');
            var grid = wrapper.querySelector('.scan-grid');
            var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

            var FLY = 2300;
            var SCAN_START = 2500;
            var SCAN_LENGTH = 2800;

            var layout = {};
            var pat = {mode: null, start: 0, count: 0, timer: 0, from: null, rotation: 0};
            var startedAt = 0;
            var frameId = 0;
            var previous = null;
            var tilt = 0;
            var visible = true;

            function clamp(value, min, max) {
                return Math.max(min, Math.min(max, value));
            }

            function easeInOut(t) {
                return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
            }

            function easeOut(t) {
                return 1 - Math.pow(1 - t, 3);
            }

            function bezier(a, b, c, d, t) {
                var u = 1 - t;

                return u * u * u * a + 3 * u * u * t * b + 3 * u * t * t * c + t * t * t * d;
            }

            /**
             * Current slide image the drone is positioned against.
             *
             * @returns {HTMLImageElement|null}
             */
            function activeImage() {
                return slider.querySelector('.slick-current img.absolute-image:not(.d-none)')
                    || slider.querySelector('img.absolute-image:not(.d-none)')
                    || slider.querySelector('img.absolute-image');
            }

            /**
             * Maps a point given as a percentage of the photo to a pixel position inside
             * the slider, matching the crop produced by object-fit: cover.
             *
             * @param {number} px
             * @param {number} py
             * @returns {{x: number, y: number}}
             */
            function mapPoint(px, py) {
                var w = layout.width;
                var h = layout.height;
                var nw = layout.naturalWidth;
                var nh = layout.naturalHeight;
                var scale = Math.max(w / nw, h / nh);

                return {
                    x: (w - nw * scale) / 2 + (px / 100) * nw * scale,
                    y: (h - nh * scale) / 2 + (py / 100) * nh * scale
                };
            }

            function measure() {
                var image = activeImage();

                layout.width = wrapper.clientWidth;
                layout.height = wrapper.clientHeight;
                layout.naturalWidth = image && image.naturalWidth ? image.naturalWidth : 1600;
                layout.naturalHeight = image && image.naturalHeight ? image.naturalHeight : 900;

                var target = mapPoint(
                    parseFloat(wrapper.dataset.droneX || 74),
                    parseFloat(wrapper.dataset.droneY || 34)
                );

                layout.target = {
                    x: clamp(target.x, layout.width * 0.55, layout.width - 90),
                    y: clamp(target.y, 110, layout.height * 0.45)
                };

                layout.scanFrom = layout.width * (parseFloat(wrapper.dataset.scanFrom || 46) / 100);
                grid.style.left = layout.scanFrom + 'px';
                grid.style.width = (layout.width - layout.scanFrom) + 'px';

                var size = clamp(layout.width * 0.075, 76, 124);

                [drone, shadow].forEach(function (element) {
                    element.style.width = size + 'px';
                    element.style.height = size + 'px';
                });
            }

            function place(x, y, altitude, rotation) {
                drone.style.transform = 'translate(' + x + 'px,' + y + 'px) translate(-50%,-50%) rotate('
                    + rotation + 'deg) scale(' + (1 + (altitude - 1) * 0.45) + ')';
                shadow.style.transform = 'translate(' + (x - 38 * altitude) + 'px,' + (y + 54 * altitude)
                    + 'px) translate(-50%,-50%) rotate(' + (rotation * 0.6) + 'deg) scale('
                    + (1 + (altitude - 1) * 0.25) + ')';
                shadow.style.opacity = (0.5 / Math.pow(altitude, 1.3)).toFixed(3);
            }

            function frame(time) {
                var elapsed = time - startedAt;
                var width = layout.width;
                var height = layout.height;
                var target = layout.target;
                var x;
                var y;
                var altitude;

                if (elapsed < FLY) {
                    var k = easeInOut(elapsed / FLY);

                    x = bezier(width + 130, width * 0.98, target.x + 230, target.x, k);
                    y = bezier(-100, height * 0.02, target.y - 90, target.y, k);
                    altitude = 1.8 - 0.8 * easeOut(elapsed / FLY);
                } else {
                    var hover = (elapsed - FLY) / 1000;

                    x = target.x + Math.sin(hover * 1.3) * 6;
                    y = target.y + Math.sin(hover * 2.1) * 5;
                    altitude = 1 + Math.sin(hover * 2.1) * 0.04;
                }

                if (pat.mode === 'roll') {
                    var roll = (time - pat.start) / 900;

                    if (roll >= 1) {
                        pat.mode = null;
                        pat.rotation = 0;
                    } else {
                        pat.rotation = 360 * easeInOut(roll);
                        y -= Math.sin(roll * Math.PI) * 16;
                        x += Math.sin(roll * Math.PI * 3) * 5;
                        altitude += Math.sin(roll * Math.PI) * 0.14;
                    }
                } else if (pat.mode === 'flee') {
                    var since = time - pat.start;
                    var away = {x: -150, y: height * 0.22};

                    if (since < 900) {
                        var out = easeInOut(since / 900);

                        x = pat.from.x + (away.x - pat.from.x) * out;
                        y = pat.from.y + (away.y - pat.from.y) * out;
                        altitude = 1 + 0.7 * out;
                        pat.rotation = -28 * out;
                    } else if (since < 4200) {
                        x = away.x;
                        y = away.y;
                        altitude = 1.7;
                        pat.rotation = 0;
                    } else if (since < 6300) {
                        var back = easeInOut((since - 4200) / 2100);

                        x = away.x + (target.x - away.x) * back;
                        y = away.y + (target.y - away.y) * back;
                        altitude = 1.7 - 0.7 * back;
                        pat.rotation = 0;
                    } else {
                        pat.mode = null;
                        pat.count = 0;
                    }
                }

                if (previous) {
                    tilt += (clamp((x - previous.x) * 1.5, -16, 16) - tilt) * 0.15;
                }

                previous = {x: x, y: y};
                place(x, y, altitude, tilt + pat.rotation);

                var scanEnd = SCAN_START + SCAN_LENGTH;

                if (elapsed >= SCAN_START && elapsed <= scanEnd + 100) {
                    var progress = Math.min(1, (elapsed - SCAN_START) / SCAN_LENGTH);
                    var scanX = layout.scanFrom + (width - layout.scanFrom) * easeInOut(progress);
                    var fade = progress < 0.12 ? progress / 0.12 : progress > 0.88 ? (1 - progress) / 0.12 : 1;

                    line.style.transform = 'translateX(' + scanX + 'px)';
                    line.style.opacity = fade;
                    grid.style.opacity = fade * 0.2;
                } else if (elapsed > scanEnd + 100) {
                    line.style.opacity = 0;
                    grid.style.opacity = 0;
                }

                if (!visible && !pat.mode && elapsed > scanEnd + 400) {
                    frameId = 0;

                    return;
                }

                frameId = window.requestAnimationFrame(frame);
            }

            /**
             * Runs the survey from the start. Safe to call at any point.
             */
            function start() {
                window.cancelAnimationFrame(frameId);
                frameId = 0;
                measure();
                line.style.opacity = 0;
                grid.style.opacity = 0;

                if (reduce) {
                    place(layout.target.x, layout.target.y, 1, 0);

                    return;
                }

                place(layout.width + 200, -150, 1.8, 0);
                startedAt = window.performance.now();
                previous = null;
                tilt = 0;
                pat.mode = null;
                pat.rotation = 0;
                frameId = window.requestAnimationFrame(frame);
            }

            function patDrone() {
                if (reduce || !frameId || pat.mode === 'flee') {
                    return;
                }

                window.clearTimeout(pat.timer);
                pat.count++;
                pat.timer = window.setTimeout(function () {
                    pat.count = 0;
                }, 6000);
                pat.start = window.performance.now();

                if (pat.count >= 3) {
                    pat.from = previous ? {x: previous.x, y: previous.y} : {x: layout.target.x, y: layout.target.y};
                    pat.mode = 'flee';
                } else {
                    pat.mode = 'roll';
                }
            }

            drone.addEventListener('click', patDrone);
            drone.addEventListener('keydown', function (event) {
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    patDrone();
                }
            });

            if ('IntersectionObserver' in window) {
                new IntersectionObserver(function (entries) {
                    visible = entries[0].isIntersecting;

                    if (visible && !frameId && !reduce && startedAt) {
                        frameId = window.requestAnimationFrame(frame);
                    }
                }).observe(wrapper);
            }

            if ('ResizeObserver' in window) {
                new ResizeObserver(function () {
                    measure();

                    if (reduce) {
                        place(layout.target.x, layout.target.y, 1, 0);
                    }
                }).observe(wrapper);
            } else {
                window.addEventListener('resize', measure);
            }

            if (window.jQuery) {
                window.jQuery(slider).find('.main-slider').on('afterChange', function (event, slick, current) {
                    wrapper.style.display = current === 0 ? '' : 'none';

                    if (current === 0) {
                        measure();
                    }
                });
            }

            window.setTimeout(start, 400);
        })();
    };

    module.companionDroneAnimation = function () {
        (function () {
            var companion = document.querySelector('[data-drone-companion]');

            if (!companion || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
                return;
            }

            var tilt = companion.querySelector('.tilt');
            var anchor = document.querySelector('[data-drone-anchor]') || document.querySelector('.slider-wrapper');
            var sections = Array.prototype.slice.call(document.querySelectorAll('[data-drone-scan]'));

            var y = 130;
            var targetY = 130;
            var running = false;
            var scanTimer = 0;

            function clamp(value, min, max) {
                return Math.max(min, Math.min(max, value));
            }

            function easeOut(t) {
                return 1 - Math.pow(1 - t, 3);
            }

            function loop() {
                var diff = targetY - y;

                y += diff * 0.1;
                companion.style.transform = 'translateY(' + y + 'px)';
                tilt.style.transform = 'rotate(' + clamp(diff * 0.12, -14, 14) + 'deg)';

                if (Math.abs(diff) > 0.4) {
                    window.requestAnimationFrame(loop);
                } else {
                    running = false;
                    tilt.style.transform = 'rotate(0deg)';
                }
            }

            function onScroll() {
                var max = document.documentElement.scrollHeight - window.innerHeight;
                var progress = max > 0 ? clamp(window.pageYOffset / max, 0, 1) : 0;

                targetY = 130 + progress * (window.innerHeight - 280);
                companion.classList.toggle(
                    'is-visible',
                    !anchor || anchor.getBoundingClientRect().bottom < window.innerHeight * 0.4
                );

                if (!running) {
                    running = true;
                    window.requestAnimationFrame(loop);
                }
            }

            /**
             * Counts a number up to the value held in its data-count attribute.
             *
             * @param {HTMLElement} element
             */
            function countUp(element) {
                var end = parseFloat(element.dataset.count);
                var started = window.performance.now();

                (function step(time) {
                    var progress = Math.min(1, (time - started) / 1500);

                    element.textContent = Math.round(end * easeOut(progress)).toLocaleString('en-GB');

                    if (progress < 1) {
                        window.requestAnimationFrame(step);
                    }
                })(started);
            }

            window.addEventListener('scroll', onScroll, {passive: true});
            window.addEventListener('resize', onScroll);
            onScroll();

            if (sections.length && 'IntersectionObserver' in window) {
                var observer = new IntersectionObserver(function (entries) {
                    entries.forEach(function (entry) {
                        if (!entry.isIntersecting || entry.target.dataset.droneScanned) {
                            return;
                        }

                        entry.target.dataset.droneScanned = '1';
                        companion.classList.add('is-scanning');
                        window.clearTimeout(scanTimer);
                        scanTimer = window.setTimeout(function () {
                            companion.classList.remove('is-scanning');
                        }, 1500);

                        window.setTimeout(function () {
                            Array.prototype.forEach.call(entry.target.querySelectorAll('[data-count]'), countUp);
                        }, 350);
                    });
                }, {rootMargin: '0px 0px -35% 0px'});

                sections.forEach(function (section) {
                    observer.observe(section);
                });
            }
        })();
    };

    module.rainAnimation = function () {
        (function () {
            var canvases = Array.prototype.slice.call(document.querySelectorAll('canvas[data-rain]'));

            if (!canvases.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
                return;
            }

            var ABOVE = 120;
            var SPACING = 16;
            var SPEED = 9;
            var WIND = 0.12;
            var LAND_CHANCE = 0.35;

            function clamp(value, min, max) {
                return Math.max(min, Math.min(max, value));
            }

            /**
             * Rain falling across a section, with drops landing on its top edge and
             * running along any corner radius before dripping off.
             *
             * @param {HTMLCanvasElement} canvas
             * @constructor
             */
            function Rain(canvas) {
                this.canvas = canvas;
                this.host = canvas.parentElement;
                this.context = canvas.getContext('2d');
                this.drops = [];
                this.splashes = [];
                this.runners = [];
                this.falls = [];
                this.frameId = 0;
                this.visible = false;
                this.last = 0;
                this.time = 0;

                this.resize();

                var self = this;

                if ('ResizeObserver' in window) {
                    new ResizeObserver(function () {
                        self.resize();
                    }).observe(this.host);
                } else {
                    window.addEventListener('resize', function () {
                        self.resize();
                    });
                }

                if ('IntersectionObserver' in window) {
                    new IntersectionObserver(function (entries) {
                        self.visible = entries[0].isIntersecting;

                        if (self.visible && !self.frameId) {
                            self.last = window.performance.now();
                            self.frameId = window.requestAnimationFrame(function (time) {
                                self.tick(time);
                            });
                        }
                    }, {rootMargin: '150px'}).observe(this.host);
                }
            }

            Rain.prototype.resize = function () {
                var ratio = Math.min(window.devicePixelRatio || 1, 2);

                this.width = this.canvas.clientWidth;
                this.height = this.canvas.clientHeight;
                this.canvas.width = this.width * ratio;
                this.canvas.height = this.height * ratio;
                this.context.setTransform(ratio, 0, 0, ratio, 0, 0);
                this.radius = parseFloat(window.getComputedStyle(this.host).borderTopLeftRadius) || 0;

                var wanted = Math.round(this.width / SPACING);

                while (this.drops.length < wanted) {
                    this.drops.push(this.newDrop(true));
                }

                this.drops.length = wanted;
            };

            Rain.prototype.newDrop = function (anywhere) {
                return {
                    x: Math.random() * (this.width + 80) - 40,
                    y: anywhere ? Math.random() * this.height : -30 - Math.random() * this.height * 0.25,
                    speed: SPEED * (0.75 + Math.random() * 0.5),
                    length: 10 + Math.random() * 14,
                    land: Math.random() < LAND_CHANCE,
                    alive: true
                };
            };

            /**
             * Vertical position of the section's top edge at a given x, following the
             * corner radius.
             *
             * @param {number} x
             * @returns {number}
             */
            Rain.prototype.edgeY = function (x) {
                var r = this.radius;
                var distance;

                if (x < r) {
                    distance = r - x;

                    return ABOVE + r - Math.sqrt(Math.max(0, r * r - distance * distance));
                }

                if (x > this.width - r) {
                    distance = x - (this.width - r);

                    return ABOVE + r - Math.sqrt(Math.max(0, r * r - distance * distance));
                }

                return ABOVE;
            };

            Rain.prototype.bead = function (x, y, radius) {
                var context = this.context;

                context.fillStyle = 'rgba(154, 214, 255, .9)';
                context.beginPath();
                context.arc(x, y, radius, 0, Math.PI * 2);
                context.fill();
                context.fillStyle = 'rgba(255, 255, 255, .9)';
                context.beginPath();
                context.arc(x - radius * 0.35, y - radius * 0.35, radius * 0.35, 0, Math.PI * 2);
                context.fill();
            };

            Rain.prototype.tick = function (time) {
                var delta = Math.min(3, (time - this.last) / 16.67);
                var context = this.context;
                var self = this;

                this.last = time;
                this.time += delta;
                context.clearRect(0, 0, this.width, this.height);
                context.lineCap = 'round';
                context.lineWidth = 1.2;

                this.drops.forEach(function (drop) {
                    if (!drop.alive) {
                        Object.assign(drop, self.newDrop(false));
                    }

                    var previousY = drop.y;

                    drop.y += drop.speed * delta;
                    drop.x += drop.speed * WIND * delta;

                    if (drop.land) {
                        var edge = self.edgeY(drop.x);

                        if (previousY < edge && drop.y >= edge) {
                            drop.alive = false;
                            self.splashes.push({x: drop.x, y: edge, life: 1});

                            var nearCorner = drop.x < self.radius * 2.5 || drop.x > self.width - self.radius * 2.5;

                            if (nearCorner && Math.random() < 0.5 && self.runners.length < 14) {
                                self.runners.push({
                                    x: drop.x,
                                    direction: drop.x < self.width / 2 ? -1 : 1,
                                    speed: 0.3 + Math.random() * 0.3,
                                    radius: 1.8 + Math.random() * 1.2,
                                    hang: 0
                                });
                            }

                            return;
                        }
                    }

                    if (drop.y - drop.length > self.height) {
                        drop.alive = false;

                        return;
                    }

                    context.strokeStyle = drop.y < self.edgeY(drop.x)
                        ? 'rgba(70, 110, 150, .28)'
                        : 'rgba(255, 255, 255, .13)';
                    context.globalAlpha = clamp(drop.y / ABOVE, 0, 1);
                    context.beginPath();
                    context.moveTo(drop.x, drop.y);
                    context.lineTo(drop.x - drop.length * WIND, drop.y - drop.length);
                    context.stroke();
                });

                context.globalAlpha = 1;

                this.splashes = this.splashes.filter(function (splash) {
                    splash.life -= 0.06 * delta;

                    if (splash.life <= 0) {
                        return false;
                    }

                    context.strokeStyle = 'rgba(154, 214, 255, ' + (splash.life * 0.7).toFixed(3) + ')';
                    context.beginPath();
                    context.ellipse(
                        splash.x,
                        splash.y - 1,
                        (1 - splash.life) * 7 + 1,
                        (1 - splash.life) * 2.4 + 0.5,
                        0,
                        Math.PI,
                        Math.PI * 2
                    );
                    context.stroke();

                    return true;
                });

                this.runners = this.runners.filter(function (runner) {
                    if (runner.hang) {
                        runner.hang += delta;
                        runner.radius += 0.025 * delta;

                        if (runner.hang > 45) {
                            self.falls.push({x: runner.x, y: runner.y, speed: 0.6, radius: runner.radius, from: runner.y});

                            return false;
                        }
                    } else {
                        var inCorner = runner.x < self.radius || runner.x > self.width - self.radius;

                        runner.speed += (inCorner ? 0.07 : 0.006) * delta;
                        runner.x += runner.direction * runner.speed * delta;

                        if (runner.direction < 0 && runner.x <= 2) {
                            runner.x = 2;
                            runner.hang = 1;
                        }

                        if (runner.direction > 0 && runner.x >= self.width - 2) {
                            runner.x = self.width - 2;
                            runner.hang = 1;
                        }
                    }

                    runner.y = self.edgeY(runner.x) - (runner.hang ? -runner.radius * 0.6 : runner.radius * 0.7);
                    self.bead(runner.x, runner.y, runner.radius);

                    return true;
                });

                this.falls = this.falls.filter(function (fall) {
                    fall.speed += 0.22 * delta;
                    fall.y += fall.speed * delta;

                    var alpha = clamp(1 - (fall.y - fall.from) / 260, 0, 1);

                    if (alpha <= 0 || fall.y > self.height) {
                        return false;
                    }

                    context.globalAlpha = alpha;
                    context.strokeStyle = 'rgba(154, 214, 255, .5)';
                    context.beginPath();
                    context.moveTo(fall.x, fall.y);
                    context.lineTo(fall.x, fall.y - Math.min(18, fall.speed * 3));
                    context.stroke();
                    self.bead(fall.x, fall.y, fall.radius);
                    context.globalAlpha = 1;

                    return true;
                });

                if (!this.visible) {
                    this.frameId = 0;

                    return;
                }

                this.frameId = window.requestAnimationFrame(function (next) {
                    self.tick(next);
                });
            };

            canvases.forEach(function (canvas) {
                new Rain(canvas);
            });
        })();
    };

    return module;

};


